<template>
  <div class="" v-if="detail"  :style="{backgroundColor:detail.backgroundColor}">
    <div>
      <img :src="detail.h5BannerImage" width="100%" alt="">
    </div>
    <div class="form-box">
      <van-form class="form" label-width="100%" ref="form" disabled >
        <div class="form-title">参会人信息</div>
        <van-field
          v-model="detail.userName"
          name="userName"
          label="姓名"
          required
          :maxlength="10"
          placeholder="请填写参会人的姓名"
          :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <van-field
          v-model="detail.userPosition"
          name="userPosition"
          label="职位"
          required
          :maxlength="100"
          placeholder="请填写参会人的职位"
          :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <van-field
          v-model="detail.phone"
          name="phone"
          label="电话"
          required
          :maxlength="11"
          placeholder="请填写参会人的电话"
          :rules="[]"
        />
<!--        <div  class="code-box">
          <van-field
            class="code-input"
            v-model="detail.verificationCode"
            name="verificationCode"
            label="验证码"
            required
            :maxlength="6"
            placeholder="请填写手机验证码"
            :rules="[
              { required: true, message: '不可为空' },
            ]"
          >
           <template #button>
              <van-button class="code-btn" size="small" type="info" native-type="button" disabled>
                {{ verifyCodeEmailMsg || '获取验证码' }}
              </van-button>
            </template>
          </van-field>
        </div>-->
        <div class="code-box">
          <van-field
              class="code-input"
              v-model="detail.verificationCode"
              name="verificationCode"
              label="图形验证码"
              required
              :maxlength="4"
              placeholder="请填写图形验证码"
              :rules="[
              { required: true, message: '不可为空' },
            ]"
          >
            <template #button>
              <img class="code-img" :src="reflashVerifyCodeUrl" alt="图形验证码">
            </template>
          </van-field>
        </div>
        <van-field
          v-model="detail.email"
          name="email"
          label="电子邮箱"
          required
          placeholder="请填写参会人的电子邮箱"
          :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <van-field
          v-model="detail.companyName"
          name="companyName"
          label="企业名称"
          required
          :maxlength="100"
          placeholder="请填写参会人的企业名称"
          :rules="[
            { required: true, message: '不可为空' },
          ]"
        />
        <van-field
          v-model="detail.productName"
          name="productName"
          label="产品名称"
          :maxlength="100"
          placeholder="请填写你负责的产品或业务名称"
          :rules="[]"
        />
        <van-field
          type="textarea"
          v-model="detail.companyDesc"
          name="companyDesc"
          label="企业简介"
          :maxlength="100"
          show-word-limit
          placeholder="请填写企业简介，中文，不超过100字"
          :autosize="{minHeight: 100 }"
        />
        <div style="margin-top: 16px;">
          <van-button class="radius" block type="info" disabled native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
    <div class="rule-box">
      <div class="rule">
        <div class="rule-title">报名须知</div>
        <div v-if="detail.rules"  class="rule-content" v-html="detail.rules">

        </div>
        <div v-else class="rule-content" >

        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail:'',
      verifyCodeEmailMsg:'',
      reflashVerifyCodeUrl:'',
    };
  },
  created() {
    this.detail = JSON.parse(decodeURIComponent(this.$route.query.data))
    this.getVerification() // 获取验证码
  },
  methods: {
    // 获取图形验证码
    async getVerification(){
      this.$apis.developersConferenceServer.getmVerificationCode({type: 8}).then(res => {
        if (res["code"] == 0) {
          this.reflashVerifyCodeUrl = 'data:image/png;base64,' + res.data.codeImage
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.rule-box{
  padding:  80px 32px;
  .rule{
    border-radius: 10px;
    .rule-title{
      position: relative;
      margin-bottom: 64px;
      font-weight: bold;
      font-size: 40px;
      color: #fff;
      text-shadow: 0px 0px 7px rgba(255,255,255,0.25), 0px 4px 4px rgba(3,66,180,0.3);
      &::after{
        content: '';
        position: absolute;
        left: 0;
        bottom: -32px;
        width: 100px;
        height: 12px;
        background: linear-gradient( 359deg, #0A40DD 0%, #0C43DC 100%);
        border-radius: 8px ;
      }
    }
    .rule-content{
      min-height: 300px;
      line-height: 38px;
      color: #DDDDDD;
      white-space: pre-line; /* 合并空格但保留换行 */
    }
  }
}
.form-box{
  padding:  80px 32px 0px 32px;
  /deep/ .van-cell--required::before {
    top: 10px;
    left:7px;
  }
  /deep/ .van-field__control {
    display: block; 
    padding: 15px 30px;
    background-color: #19191B;
    font-size: 28px;
    color: #ccc;
    border-radius: 8px;
  }
  
  /deep/ .van-field__control::placeholder {
    color: #666666 !important;
    -webkit-text-fill-color: #666666 !important;
    font-size: 24px;
  }
  /deep/.van-field {
    display: block; 
  }

  /deep/ .van-field__label {
    display: block; 
    margin-right: 0;
    margin-bottom: 14px;
    color: #ccc ;
  }
  /deep/ .van-cell__value {
    margin-left: -14px;
  }
  /deep/ .van-field__error-message {
    margin-top: 10px;
  }
  /deep/ .van-cell{
    background-color:transparent;
  }
  /deep/ .van-cell::after{
    border-bottom:0;
  }
  .form{
    .form-title{
      position: relative;
      margin-bottom: 64px;
      font-weight: bold;
      font-size: 40px;
      color: #fff;
      text-shadow: 0px 0px 7px rgba(255,255,255,0.25), 0px 4px 4px rgba(3,66,180,0.3);
      &::after{
        content: '';
        position: absolute;
        left: 0;
        bottom: -32px;
        width: 100px;
        height: 12px;
        background: linear-gradient( 359deg, #0A40DD 0%, #0C43DC 100%);
        border-radius: 8px ;
      }
    }
    .radius{
      display: block;
      margin: auto;
      width: 320px;
      height: 80px;
      background: linear-gradient( 359deg, #0A40DD 0%, #0C43DC 100%);
      border-radius: 8px ;
      border-color: #0A40DD;
    }
    .code-box{
      display: flex;
      width: 100%;
      .code-input{
        flex: 1;
      }
      .code-btn{
        width: 292px;
        height: 64px;
        background: linear-gradient( 359deg, #0A40DD 0%, #0C43DC 100%);
        border-radius: 8px ;
        border-color: #0A40DD;
      }
      .code-img {
        width: 200px;
        height: 64px;
      }
    }
  }
}
.error-box{
  text-align: center;
  min-height:  600px;
  line-height:  600px;
  font-size: 36px;
  font-weight: bold;
}
</style>
